import React from 'react'
import PropTypes from 'prop-types'

export const TableWrapper = ({ children, breakpoint }) => {
  return (
    <div className={`table-responsive-${breakpoint}`}>
      <table className='table table-striped mb-4'>
        {children}
      </table>
    </div>
  )
}

TableWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  breakpoint: PropTypes.string
}

export default TableWrapper
